// src/LoginPage.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const LoginPage = ({ setIsAuthenticated, setUserType }) => {
  const [email, setEmail]             = useState('');
  const [password, setPassword]       = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate                       = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (res.ok) {
        // 1) Save full user in localStorage (if you need greeting, etc)
        localStorage.setItem('user', JSON.stringify(data.user));

        // 2) Mark as authenticated in memory
        setIsAuthenticated(true);

        // 3) Tell App what the role is
        setUserType(data.user.userType);

        // 4) Redirect into the protected area
        navigate('/app', { replace: true });
      } else {
        setErrorMessage(data.error || 'Login failed');
      }
    } catch (err) {
      console.error('Error during login:', err);
      setErrorMessage('An error occurred during login');
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100" style={{ background: '#f8f9fa' }}>
      <div className="card shadow" style={{ width: '350px' }}>
        <div className="card-body">
          <h2 className="card-title text-center">Login</h2>
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email address</label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                id="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
